import axios from "axios";
import { User } from "@/models/user.model";
import { Distributor } from "@/models/distributor.model";

class UserService {
    /**
     * Pobiera listę wszystkich użytkowników
     */
    async getUsers(): Promise<User[]> {
        const response = await axios.get<User[]>("/user");
        return response.data;
    }

    /**
     * Pobiera szczegóły użytkownika po ID
     * @param id ID użytkownika
     */
    async getUserById(id: string): Promise<User> {
        const response = await axios.get<User>(`/user/${id}`);
        return response.data;
    }

    /**
     * Tworzy nowego użytkownika
     * @param user Dane nowego użytkownika
     */
    async createUser(user: User): Promise<User> {
        const response = await axios.post<User>("/user", user);
        return response.data;
    }

    /**
     * Aktualizuje dane użytkownika
     * @param id ID użytkownika
     * @param user Dane do aktualizacji
     */
    async updateUser(id: string, user: Partial<User>): Promise<User> {
        const response = await axios.put<User>(`/user/${id}`, user);
        return response.data;
    }

    /**
     * Usuwa użytkownika po ID
     * @param id ID użytkownika
     */
    async deleteUser(id: string): Promise<void> {
        await axios.delete(`/user/${id}`);
    }

    /**
     * Zmienia hasło użytkownika
     * @param id ID użytkownika
     * @param oldPassword Stare hasło
     * @param newPassword Nowe hasło
     * @param confirmNewPassword Potwierdzenie nowego hasła
     */
    async changePassword(id: string, oldPassword: string, newPassword: string, confirmNewPassword: string): Promise<void> {
        await axios.put(`/user/${id}/change-password`, {
            oldPassword,
            newPassword,
            confirmNewPassword
        });
    }

    /**
     * Zmienia hasło zalogowanego użytkownika (konto wynika z tokenu)
     * @param oldPassword Obecne hasło
     * @param newPassword Nowe hasło
     * @param confirmNewPassword Potwierdzenie nowego hasła
     */
    async changeOwnPassword(oldPassword: string, newPassword: string, confirmNewPassword: string): Promise<void> {
        await axios.put("/user/me/password", {
            oldPassword,
            newPassword,
            confirmNewPassword
        });
    }

    /**
     * Ustawia nowe hasło dla użytkownika (bez starego hasła, np. reset)
     * @param id ID użytkownika
     * @param newPassword Nowe hasło
     * @param confirmNewPassword Potwierdzenie nowego hasła
     */
    async setPassword(id: string, newPassword: string, confirmNewPassword: string): Promise<void> {
        await axios.put(`/user/${id}/set-password`, {
            newPassword,
            confirmNewPassword
        });
    }
    /**
   * Przypisuje dystrybutora do użytkownika
   * @param userId ID użytkownika
   * @param distributorId ID dystrybutora
   */
    async assignDistributor(userId: string, distributorId: string): Promise<void> {
        const obj = {
            DistributorId: distributorId
        }
        await axios.put(`/user/${userId}/distributor`, obj);
    }

    /**
   * Usuwa dystrybutora od użytkownika
   * @param userId ID użytkownika
   * @param distributorId ID dystrybutora
   */
    async removeDistributor(userId: string, distributorId: string): Promise<void>
    {
        await axios.delete(`/user/${userId}/distributor/${distributorId}`)
    }

    /**
    * Przypisuje dystrybutora do użytkownika
    * @param userId ID użytkownika
    * @param distributorId ID dystrybutora
    */
    async getUserDistributor(userId: string): Promise<Distributor[]> {
        const result = await axios.get(`/user/${userId}/distributor`);
        return result.data
    }
}

// Eksportowanie instancji serwisu
export default new UserService();
